import Image from 'next/image'
import Link from 'next/link'

const Landing = _ => {
  return <div className='w-screen h-screen flex items-center justify-center'>
    <Image src='/images/crypt-universe.jpg' className='filter grayscale-50' layout='fill' quality='90' objectFit='cover'/>
    <Link href='/'>
      <div className='flex font-display font-semibold tracking-widest text-lg items-center justify-center text-white rounded-full w-24 h-24 transition-all duration-50 ease-in-out hover:w-28 hover:h-28 cursor-pointer bg-red-400 z-50' >ENTER</div>
    </Link>
  </div>
}

export default Landing 